import React from "react";

import 'components/Table/Cells/index.css';

import './index.css';


function TextCell(props) {
    const {
        isSelected,
        name,
        textClassName = ''
    } = props;

    let {
        selectedBackgroundColor = 'transparent',
    } = props;

    const backgroundColor = 'transparent'

    return (
        <div
            key={props.id}
            className='text-cell'
            style={{
                backgroundColor: isSelected ? selectedBackgroundColor : backgroundColor
            }}
        >
            <p
                className={`cell__p ${textClassName}`}
            >
                {name}
            </p>

        </div>
    )
}

export default TextCell;